import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@store';
import { PendingPayStatus } from '@types';
import { isEmpty } from 'lodash';

export const selectAutoPay = (state: RootState) => state.autoPay;

export const selectRecurringPayment = createSelector([selectAutoPay], payments => {
    if (!isEmpty(payments?.pendingPayments)) {
        return payments.pendingPayments.find((ele: PendingPayStatus) => ele?.paymentCategory.includes('Recurring Payment'));
    }
});
